import VaultSetUsersRequestBase from './base/VaultSetUsersRequestBase';

/**
 * @class VaultSetUsersRequest
 * @extends VaultSetUsersRequestBase
 */
class VaultSetUsersRequest extends VaultSetUsersRequestBase {

}

export default VaultSetUsersRequest;
